import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deletePaymentPage } from "../services/delete-payment-page";

export function useDeletePaymentPage() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => deletePaymentPage(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["payment-pages"] });
    },
  });
}
